<template>
  <v-container>
    <v-card v-if="curriculum">
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="12" md="12" class="text-right">
            <v-btn
              class="ma-auto"
              color="success"
              :to="{
                name: 'ConfigurePricingPage',
                params: {
                  id: curriculum.id,
                },
              }"
            >
              Configure Pricing
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              label=""
              v-model="curriculum.name"
              :disabled="isLoading"
              ref="input"
              hide-details
              @change="changeOrder"
              class="d-inline"
              prepend-inner-icon="fa-file-certificate"
            />
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="selectedDealer"
              :menu-props="{ closeOnClick: true }"
              :disabled="isLoading"
              :items="curriculum.single_user_dealers"
              hint="Companies shown are single user only (For the meantime)"
              persistent-hint
              clearable
              hide-selected
              label="Select Company to Modify"
              item-text="name"
              item-value="id"
              return-object
              append-icon=""
              name="selected_dealer"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="selectedDealer.courses"
              :menu-props="{ closeOnClick: true }"
              :disabled="isLoading"
              :items="curriculum.courses"
              chips
              label="Select Available Courses"
              item-text="name"
              item-value="id"
              multiple
              name="selected_courses"
              hide-details
              clearable
              append-icon=""
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              small
              @click="saveConfiguration"
              :disabled="isLoading"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="isFetching">
          <template v-for="i in 3">
            <v-col>
              <v-skeleton-loader
                v-bind="attrs"
                type="image"
              ></v-skeleton-loader>
            </v-col>
          </template>
        </v-row>
        <article v-else class="row" block text>
          <draggable
            :list="curriculum.courses"
            @change="changeOrder($event, curriculum.id)"
            @start="dragging = true"
            @end="dragging = false"
            class="row"
            :options="{ animation: 200, group: 'status' }"
            :element="'div'"
            v-model="courses"
          >
            <template v-for="(course, index) in curriculum.courses">
              <v-col cols="6" sm="6" md="6" lg="4" xl="4">
                <article>
                  <v-img
                    class="white--text img-thumbnail px-3 py-3"
                    :src="
                      course.thumbnail
                        ? course.thumbnail
                        : 'https://www.ppxray.com/wp-content/themes/ppxray.com/images/thumbnail.png'
                    "
                    cover
                    style="min-height: 200px"
                    aspect-ratio="1.6"
                  >
                    <section
                      class="d-flex flex-row justify-content-between mt-1"
                    >
                      <div>
                        <h4
                          class="font-bold text-white"
                          v-text="course.name"
                        ></h4>
                        <span
                          :class="
                            course.is_draft ? 'text-warning' : 'text-success'
                          "
                          >{{ course.is_draft ? 'Draft' : 'Published' }}</span
                        >
                      </div>
                    </section>
                  </v-img>
                </article>
              </v-col>
            </template>
          </draggable>
        </article>
      </v-card-text>
    </v-card>
    <v-snackbar :timeout="0" v-model="isChanged">
      <v-btn
        class="ma-auto"
        color="success"
        :disabled="isLoading"
        :loading="isLoading"
        @click="saveCurriculumChanges"
        >Save Changes
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import { each as _each, map as _map } from 'lodash-es';

export default {
  name: 'CurriculumPage',
  components: {
    draggable,
  },
  data() {
    return {
      courses: [],
      orders: [],
      dealers: [],
      specific_dealers: [],
      isLoading: false,
      isFetching: false,
      isChanged: false,
      curriculum: null,
      showSpecificDealers: false,
      selectedDealer: {
        courses: [],
      },
    };
  },

  created() {
    this.fetchCurriculum();
    this.fetchDealers();
    this.fetchSpecificDealers();
  },

  methods: {
    changeOrder(e) {
      this.isChanged = true;
      this.orders = _map(this.curriculum.courses, 'id');
    },
    saveConfiguration() {
      this.isLoading = true;
      this.axios
        .patch(
          '/lms-manager/update/curriculum/configuration/' +
            this.$route.params.id,
          {
            courses: this.selectedDealer.courses,
            name: this.curriculum.name,
            dealer_id: this.selectedDealer ? this.selectedDealer.id : null,
          }
        )
        .then(({ data }) => {
          if (data.success) {
            this.$store.dispatch('courseCertification/setLoading', true);
            this.$store
              .dispatch('courseCertification/getCourses')
              .then(({ data }) => {
                this.$store.dispatch(
                  'courseCertification/setCourses',
                  data.curriculums
                );
                this.$nextTick(() => {
                  this.$store.dispatch('courseCertification/setLoading', false);
                  this.$notify('success', 'Successfully updated!');
                });
              });
          }
        })
        .catch(() => {
          this.$notify('error', 'No Dealer Selected');
        })
        .finally(() => {
          this.isLoading = false;
          this.isChanged = false;
        });
    },
    saveCurriculumChanges() {
      this.isLoading = true;
      this.axios
        .patch('/lms-manager/courses/' + this.$route.params.id, {
          courses: this.orders,
          name: this.curriculum.name,
          assigned_dealers: this.curriculum.assignedDealer,
          assigned_specific_dealers: this.curriculum.assignedSpecificDealers,
          is_draft: this.curriculum.is_draft,
        })
        .then(({ data }) => {
          this.$notify('success', 'Successfully updated!');
        })
        .catch()
        .finally(() => {
          this.isLoading = false;
          this.isChanged = false;
        });
    },
    fetchDealers() {
      this.isLoading = true;
      this.axios
        .get('client/lms/fetchMainCompanies')
        .then((data) => {
          this.dealers = data.data;
          this.isLoading = false;
        })
        .finally((data) => {
          this.isLoading = false;
        });
    },
    fetchSpecificDealers() {
      this.isLoading = true;

      if (this.curriculum.assignedDealer.length == 0) {
        this.isLoading = false;
        this.showSpecificDealers = false;
      } else {
        this.axios
          .get('client/lms/fetchSubCompanies', {
            params: {
              assigned_dealers: this.curriculum.assignedDealer,
            },
          })
          .then((data) => {
            this.specific_dealers = data.data;
            this.isLoading = false;
            if (data.data.length !== 0) {
              this.showSpecificDealers = true;
            }
          })
          .finally((data) => {
            this.isLoading = false;
          });
      }
    },
    debounceFetching() {
      clearTimeout(this.debounceTime);

      this.debounceTime = setTimeout(() => {
        this.fetchSpecificDealers();
        this.isChanged = true;
      }, 1000);
    },
    fetchCurriculum() {
      this.isLoading = true;
      this.isFetching = true;
      this.axios
        .get('/lms-manager/courses/' + this.$route.params.id, {})
        .then(({ data }) => {
          console.log(data);
          this.curriculum = data;
          this.curriculum.assignedDealer = _map(this.curriculum.dealers, 'id');
          this.curriculum.assignedSpecificDealers = _map(
            this.curriculum.specific_dealers,
            'id'
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isFetching = false;
          this.isChanged = false;
        });
    },
    debounceFetching() {
      clearTimeout(this.debounceTime);

      this.debounceTime = setTimeout(() => {
        this.fetchCurriculum();
      }, 1000);
    },
    removeCourse(item) {
      const index = this.curriculum.courses.indexOf(item.id);
      if (index >= 0) this.curriculum.courses.splice(index, 1);
      this.debounceFetching();
    },
    removeDealer(item) {
      const index = this.curriculum.assignedDealer.indexOf(item.id);
      if (index >= 0) this.curriculum.assignedDealer.splice(index, 1);
      this.debounceFetching();
    },
  },
};
</script>

<style scoped></style>
